/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const formInstances = sqliteTable('form_instances', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  form_definition_id: text('form_definition_id'),
  patient_id: text('patient_id'),
  encounter_id: text('encounter_id'),
  appointment_id: text('appointment_id'),
  queue_id: text('queue_id'),
  visit_id: text('visit_id'),
  status: text('status'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  updated_by: text('updated_by'),
  completed_at: text('completed_at'),
});
